"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _TypographyTheme3 = _interopRequireDefault(require("./TypographyTheme"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var TableCellTheme = function TableCellTheme(colors, breakpoints) {
  var _TypographyTheme, _TypographyTheme$styl, _TypographyTheme2, _TypographyTheme2$sty;

  return {
    styleOverrides: {
      root: _objectSpread(_objectSpread({}, ((_TypographyTheme = (0, _TypographyTheme3["default"])(colors, breakpoints)) === null || _TypographyTheme === void 0 ? void 0 : (_TypographyTheme$styl = _TypographyTheme.styleOverrides) === null || _TypographyTheme$styl === void 0 ? void 0 : _TypographyTheme$styl.body2) || {}), {}, {
        boxSizing: 'border-box',
        height: '46px',
        padding: '15px'
      }),
      head: _objectSpread(_objectSpread({}, ((_TypographyTheme2 = (0, _TypographyTheme3["default"])(colors, breakpoints)) === null || _TypographyTheme2 === void 0 ? void 0 : (_TypographyTheme2$sty = _TypographyTheme2.styleOverrides) === null || _TypographyTheme2$sty === void 0 ? void 0 : _TypographyTheme2$sty.subtitle2) || {}), {}, {
        color: colors.ultramarine,
        height: '64px'
      }),
      body: {
        color: 'inherit'
      },
      paddingCheckbox: {
        padding: '0 24px'
      },
      alignRight: {
        flexDirection: 'row'
      }
    }
  };
};

var _default = TableCellTheme;
exports["default"] = _default;